<script>
import { store } from '../../functions/mixins';
import UiButton from '../ui/Button';

export default {
    mixins: [store],
    components: {
        UiButton,
    },
    created() {
        this.out = atob(this.$route.params.outUrl);
        this.back = JSON.parse(atob(this.$route.params.backRoute));
    },
    data: () => ({
        out: null,
        back: null,
    }),
    methods: {
        goBack() {
            this.$router.push(this.back);
        },
    },
}
</script>

<template>
    <div class="OutsideContainer">
        <iframe class="Frame" :src="out"></iframe>
        <div class="Navigation">
            <div class="Back">
                <ui-button @click.native="goBack()" class="clear">
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="8" height="14" viewBox="0 0 8 14" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.287 7.694l6.04 6.022a.987.987 0 001.392 0 .979.979 0 000-1.387L2.374 7l5.345-5.328a.979.979 0 000-1.387.987.987 0 00-1.392 0L.287 6.307a.983.983 0 000 1.387z"/></svg>
                    {{ $t('bottomSheet.back') }}
                </ui-button>
            </div>
        </div>
    </div>
</template>

<style lang="stylus">
@import '../../stylus/vars.styl'

.OutsideContainer
    width 100%
    height 100%
    display flex
    flex-direction column
    align-items stretch
    .Frame
        border none
        flex 1 1 auto
    .Navigation
        background #fff
        box-shadow 0 0 4px rgba(0,0,0,.1)
        position relative
        height 100px
        display flex
        align-items center
        overflow hidden
        transition .3s all
        .Back, .Next
            position absolute
            padding 0
            transition .3s all
            .mr-3, .ml-3
                transition .3s all
            &:before, &:after
                content ''
                position absolute
                transition .3s all
            &:before
                width 1px
                background $cBorder
                top -100px
                bottom -100px
            &:after
                width 3px
                background $cAccent
                top 5px
                bottom 5px
            &:hover:after
                width 7px
        .Next
            right 0
        .Back:before
            right 0
        .Back:after
            right -1px
        .Next:before
            left 0
        .Next:after
            left -1px
        .Back:hover
            &:after
                right -3px
            .mr-3
                transform translate(-20px,0)
        .Next:hover
            &:after
                left -3px
            .ml-3
                transform translate(20px,0)
</style>

